// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/components/header/navigationConfig.tsx
// Version: v1.0.1
// Description: Zentrale Navigations-Konfiguration mit i18n-Unterstützung
export type DropdownType = 'services' | 'industries' | 'about' | 'career';

export interface NavigationItem {
  name: string;
  href: string;
  hasDropdown: boolean;
  dropdownType?: DropdownType;
}

// Übersetzbare Navigation
export const getNavigationConfig = (t: (key: string) => string): NavigationItem[] => [
  {
    name: t('navigation.services'),  // Label darf "Expertise" bleiben
    href: '/services',
    hasDropdown: true,
    dropdownType: 'services',         // <-- WICHTIG: jetzt "services"
  },
  {
    name: t('navigation.industries'),
    href: '/industries',
    hasDropdown: true,
    dropdownType: 'industries',
  },
  {
    name: t('navigation.career'),
    href: '/careers',
    hasDropdown: true,
    dropdownType: 'career',
  },
  {
    name: t('navigation.about'),
    href: '/about',
    hasDropdown: true,
    dropdownType: 'about',
  },
];
